// extracted by mini-css-extract-plugin
export default {"DeleteForm":"MfaDisable_DeleteForm__NDdPI","FormField":"MfaDisable_FormField__CNmHd","SubmitRegion":"MfaDisable_SubmitRegion__ePxhS","FormSubmit":"MfaDisable_FormSubmit__S5PxG"};